import { createSelector } from "reselect";

import { PaginationResult } from "./models";

// Pagination selectors
type GetPaginationSelector = (state: any, props?: any) => PaginationResult;

export const makeHasMorePages = (getPagination: GetPaginationSelector) => createSelector(
    getPagination,
    hasMorePages,
);

export const makeGetNextPage = (getPagination: GetPaginationSelector) => createSelector(
    getPagination,
    getNextPage,
);

export const makeHasMorePagesParametric =
(getPagination: GetPaginationSelector) => createSelector<any, any, PaginationResult, any>(
        getPagination,
        hasMorePages,
    );

export const makeGetNextPageParametric =
    (getPagination: GetPaginationSelector) => createSelector<any, any, PaginationResult, any>(
        getPagination,
        getNextPage,
    );

// Helper functions
const hasMorePages = (pagination: PaginationResult) => pagination != null && pagination.nextLink != null;

const getNextPage = (pagination: PaginationResult) => {
    const morePages = hasMorePages(pagination);
    return pagination != null && morePages ? pagination.page + 1 : null;
};
